import Box from '@mui/material/Box';
import { useTheme } from '@mui/material';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { setBlurActive } from 'store/features/meeting/slice';
import { selectBlurActive, selectMeetingMode } from 'store/features/meeting/selector';

const BlurOverlay = () => {
  // other hooks
  const theme = useTheme();

  // redux hooks
  const dispatch = useAppDispatch();
  const blurActive = useAppSelector(selectBlurActive);
  const meetingMode = useAppSelector(selectMeetingMode);

  // dynamic variables
  const bgColor =
    theme.palette.mode === 'dark'
      ? 'rgba(0,0,0,0.35)' // dark mode overlay
      : 'rgba(255,255,255,0.45)'; // light mode overlay

  if (!meetingMode || !blurActive) return null;

  return (
    <Box
      onClick={() => dispatch(setBlurActive(false))}
      sx={{
        position: 'fixed',
        top: '64px', // header height
        left: 0,
        width: '100vw',
        height: 'calc(100vh - 64px)',
        backdropFilter: 'blur(12px)',
        bgcolor: bgColor,
        zIndex: 2000,
        cursor: 'pointer',
      }}
    />
  );
};

export default BlurOverlay;
